import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {TemplateGraphic} from "./template-graphic.model";
import {PaginatedResult} from "../app-store-entity.service";

@Injectable({providedIn: 'root'})
export class TemplateGraphicService {
    constructor(private http: HttpClient) {
    }

    clone(id: number, cloneProducts: boolean): Observable<TemplateGraphic> {
      return this.http.get<TemplateGraphic>(
          `${environment.rootUrl}/template/clone/${id}/${cloneProducts}`
      );
    }

  updateWithResources(entities: TemplateGraphic[]): Observable<TemplateGraphic[]> {
    return this.http.post<TemplateGraphic[]>(
      `${environment.rootUrl}/template-graphic/update-resources/`,
      entities
    );
  }

  selectUniqueArticles(productCategoryIds: number[], pageNumber: number, pageSize: number, searchValue?: string, resourceItemType?: number): Observable<PaginatedResult<TemplateGraphic>> {
    return this.http.post<PaginatedResult<TemplateGraphic>>(
      `${environment.rootUrl}/template-graphic/select-unique-articles/`,
      { productCategoryIds, pageNumber, pageSize, searchValue, resourceItemType }
    );
  }
}
